import {vh, startTypeShuffle, startWhichSizeVideo, whichSizeVideo, toggleModalSketch, scrubVideoOnScroll} from "../components/utils";
import {gsapContext} from "../components/theme-scripts";

export function templateProjectInit() {

	const body = document.body;

	const section1Panel0 = document.querySelector('.section-1__panel--0');
	const section1Panel1 = document.querySelector('.section-1__panel--1');
	const section1Panel2 = document.querySelector('.section-1__panel--2');
	const section1Panel3 = document.querySelector('.section-1__panel--3');
	const section1Panel4 = document.querySelector('.section-1__panel--4');
	const section1Panel5 = document.querySelector('.section-1__panel--5');
	const section2 = document.querySelector('.section-2');

	gsapContext.add(() => {
		/**
		 * Click and hold
		 */
		/*
		let holdButton = document.querySelector('.click-n-hold')

		if (holdButton !== null)
		{
			let holdTimerId;
			let holdTime = 800;

			function startHolding() {
				holdTimerId = setTimeout(finishedHolding, holdTime);
				holdButton.classList.add('holding');
			}

			function stopHolding() {
				clearTimeout(holdTimerId);
				holdButton.classList.remove('holding');
			}

			function finishedHolding() {
				holdButton.classList.remove('holding');

				const smoothScroll = new scrollToSmooth('a');
				smoothScroll.init();
				smoothScroll.scrollBy(window.innerHeight);
			}

			holdButton.style.setProperty("--hold-time", holdTime + 'ms');
			holdButton.addEventListener('mousedown', startHolding);
			holdButton.addEventListener('mouseup', stopHolding);
		}
		*/


		/**
		 * Pin animation for section-1 panels
		 */
		let panels = gsap.utils.toArray('.section-1__panel');

		gsap.to(panels, {
			ease:          'none',
			scrollTrigger: {
				trigger: '.section-1',
				pin:     true,
				scrub:   0.1,
				end:  () =>      '+=' + vh(1050), // total length of .section-1 = 1150vh
				//markers: true
			}
		});


		/**
		 * Mask animation
		 */
		const section1Mask = document.getElementById('section-1-mask-path');

		if (section1Mask !== null)
		{
			const pathTo = section1Mask.dataset.pathTo;

			gsap.timeline({
				scrollTrigger: {
					trigger: section1Mask,
					start:  () =>    'top top',
					end:  () =>      'bottom top',
					scrub:   1,
					//markers: true
				}
			})
				.to(section1Mask, {
					ease: 'none',
					attr: {d: pathTo}
				});
		}

		/**
		 * Animations for section-1__panel--0 elements
		 */
		startTypeShuffle(section1Panel0);

		/*gsap.to(section1Panel0.querySelector(':scope > div'), {
			bottom:        '100%',
			opacity:       0,
			scrollTrigger: {
				trigger: section1Panel0,
				start:  () =>    'top top',
				end:  () =>      '+=' + vh(50),
				scrub:   1
			}
		});

		gsap.to(section1Panel0, {
			backgroundColor: 'rgba(0,0,0,0)',
			ease:            'none',
			scrollTrigger:   {
				trigger: section1Panel0,
				start:  () =>    'top top',
				end:  () =>      '+=' + vh(50),
				scrub:   1
			}
		});*/

		gsap.to(section1Panel0.querySelector('.title'), {
			top:           '-100px',
			opacity:       0,
			scrollTrigger: {
				trigger: section1Panel0,
				start:  () =>    'top top',
				end:  () =>      '+=' + vh(50),
				scrub:   1
			}
		});

		gsap.to(section1Panel0, {
			opacity:       0,
			ease:          'none',
			scrollTrigger: {
				trigger: section1Panel0,
				start:  () =>    'top top',
				end:  () =>      '+=' + vh(50),
				scrub:   1
			}
		});


		/**
		 * Animations for section-1__panel--1 elements
		 */
		ScrollTrigger.create({
			trigger:     section1Panel1,
			start:  () =>        'top+=' + vh(90) + ' top',
			end:  () =>          '+=' + vh(110),
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section1Panel1);
			},
			//markers:     true
		});


		/**
		 * Animations for section-1__panel--2
		 */
		gsap.to(section1Panel2, {
			left:          0,
			ease:          'none',
			scrollTrigger: {
				trigger: section1Panel2,
				start:  () =>    'top+=' + vh(100) + ' top',
				end:  () =>      '+=' + vh(200),
				scrub:   1,
				onEnter:     () => {
					startTypeShuffle(section1Panel2.querySelector('.text-1'));

					startWhichSizeVideo(section1Panel2);
				},
				//markers:             {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});


		/**
		 * Animations for section-1__panel--2 elements
		 */
		ScrollTrigger.create({
			trigger:     section1Panel2,
			start:       () => 'top+=' + vh(250) + ' top',
			end:         () => '+=' + vh(150),
			toggleClass: 'trigger-1',
			//markers:     true
		});

		ScrollTrigger.create({
			trigger:     section1Panel2,
			start:  () =>        'top+=' + vh(400) + ' top',
			end:  () =>          '+=' + vh(200),
			toggleClass: 'trigger-2',
			onEnter:     () => {
				startTypeShuffle(section1Panel2.querySelector('.text-2'));
			},
			onToggle:    ({progress, direction, isActive}) => {
				toggleModalSketch(section1Panel2, isActive);
			},
			//markers:     true
		});


		/**
		 * Animations for section-1__panel--3
		 */
		gsap.to(section1Panel3, {
			top:           '-100%',
			ease:          'none',
			scrollTrigger: {
				trigger: section1Panel3,
				start:  () =>    'top+=' + vh(600) + ' top',
				end:  () =>      '+=' + vh(100),
				scrub:   1,
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});

		gsap.to(section1Panel3, {
			opacity:       1,
			ease:          'none',
			scrollTrigger: {
				trigger: section1Panel3,
				start:  () =>    'top+=' + vh(500) + ' top',
				end:  () =>      '+=' + vh(100),
				scrub:   1,
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});

		gsap.to(section1Panel2, {
			opacity:       0,
			scale:         2,
			ease:          'none',
			scrollTrigger: {
				trigger: section1Panel3,
				start:  () =>    'top+=' + vh(500) + ' top',
				end:  () =>      '+=' + vh(100),
				scrub:   1,
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});


		/**
		 * Animations for section-1__panel--4
		 */
		gsap.to(section1Panel4, {
			top:           0,
			ease:          'none',
			scrollTrigger: {
				trigger: section1Panel4,
				start:  () =>    'top+=' + vh(500) + ' top',
				end:  () =>      '+=' + vh(100),
				scrub:   1,
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});

		ScrollTrigger.create({
			trigger:     section1Panel4,
			start:  () =>        'top+=' + vh(650) + ' top',
			end:  () =>          '+=' + vh(150),
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section1Panel4);
			},
			//markers:     true
		});

		ScrollTrigger.create({
			trigger:     section1Panel4,
			start:  () =>        'top+=' + vh(800) + ' top',
			end:  () =>          '+=' + vh(100),
			toggleClass: 'trigger-2',
			//markers:     true
		});


		/**
		 * Animations for section-1__panel--5
		 */
		gsap.to(section1Panel5, {
			opacity:       1,
			ease:          'none',
			scrollTrigger: {
				trigger: section1Panel5,
				start:  () =>    'top+=' + vh(900) + ' top',
				end:  () =>      '+=' + vh(100),
				scrub:   1,
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});


		/**
		 * Animations for section-1__panel--5 elements
		 */
		gsap.to(section1Panel5.querySelector('.title'), {
			top:           '50%',
			opacity:       1,
			scale:         1,
			ease:          'none',
			scrollTrigger: {
				trigger: section1Panel5,
				start:  () =>    'top+=' + vh(950) + ' top',
				end:  () =>      '+=' + vh(100),
				scrub:   1,
				onEnter: () => {
					startTypeShuffle(section1Panel5);
				},
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});


		/**
		 * Animations for section-2 elements
		 */
		gsap.from(section2.querySelectorAll('.text-1 .title, .text-1 p'), {
			translateX:    -100,
			opacity:       0,
			ease:          'none',
			stagger:       0.15,
			scrollTrigger: {
				trigger: section2,
				start:  () =>    'top+=' + vh(220) + ' top',
				end:  () =>      '+=' + vh(100),
				scrub:   1,
				onEnter: () => {
					startTypeShuffle(section2.querySelector('.text-1'));
				},
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});

		gsap.from(section2.querySelectorAll('.text-2 .title, .text-2 p'), {
			translateX:    100,
			opacity:       0,
			ease:          'none',
			stagger:       0.15,
			scrollTrigger: {
				trigger: section2,
				start:  () =>    'top+=' + vh(220) + ' top',
				end:  () =>      '+=' + vh(100),
				scrub:   1,
				onEnter: () => {
					startTypeShuffle(section2.querySelector('.text-2'));
				},
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});


		/*gsap.to(section1Panel4.querySelector('img:nth-child(1)'), {
			scale:         2,
			ease:          'none',
			scrollTrigger: {
				trigger: section1Panel4,
				start:  () =>    'top+=' + vh(500) + ' top',
				end:  () =>      '+=' + vh(100),
				scrub:   1,
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});

		gsap.to(section1Panel4.querySelector('img:nth-child(2)'), {
			opacity:       1,
			scale:         2,
			ease:          'none',
			scrollTrigger: {
				trigger: section1Panel4,
				start:  () =>    'top+=' + vh(500) + ' top',
				end:  () =>      '+=' + vh(100),
				scrub:   1,
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});

		gsap.to(section1Panel4.querySelector('img:nth-child(3)'), {
			opacity:       1,
			ease:          'none',
			scrollTrigger: {
				trigger: section1Panel4,
				start:  () =>    'top+=' + vh(700) + ' top',
				end:  () =>      '+=' + vh(100),
				scrub:   1,
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});*/

		/*gsap.to(".section-0__wireframe",
			{
				x:             () => {
					return -(document.querySelector('.section-0__wireframe').offsetWidth - window.innerWidth)
				},
				ease:          "none",
				scrollTrigger: {
					trigger: ".section-0",
					start:  () =>    "top top",
					end:  () =>      "bottom bottom",
					pin:     '.section-0__wireframe',
					scrub:   1,
					//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
				}
			});*/


		let video = document.getElementById('robert');

		if (video !== null)
		{
			whichSizeVideo(video);

			let videoScrollTrigger = {
				trigger: '.section-2',
				start:  () =>    "top top",
				end:  () =>      "bottom bottom",
				scrub:   1
			};
			scrubVideoOnScroll(video, videoScrollTrigger);
		}

		let videoWireframe = document.getElementById('video-wireframe');

		if (videoWireframe !== null)
		{
			whichSizeVideo(videoWireframe);
		}
	});
}